import {
  IconActivity,
  IconSparkles,
  IconArrowsRightLeft,
  IconBarcode,
  IconBook,
  IconBuildingBank,
  IconBuildingStore,
  IconBuildingWarehouse,
  IconCalendarEvent,
  IconClockHour4,
  IconFileInvoice,
  IconReportMoney,
  IconCalculator,
  IconCarrot,
  IconCash,
  IconCategory,
  IconChartBar,
  IconCoin,
  IconShoppingCartPlus,
  IconClipboardCheck,
  IconClockExclamation,
  IconDeviceDesktop,
  IconDiscount2,
  IconHeadphones,
  IconHistory,
  IconLayout2,
  IconLayoutDashboard,
  IconMessage2,
  IconLayoutGrid,
  IconPackage,
  IconReceipt2,
  IconSettings,
  IconWriting,
  IconShieldLock,
  IconShoppingCart,
  IconSitemap,
  IconToolsKitchen2,
  IconTruckDelivery,
  IconWorld,
  IconForms,
  IconGift,
  IconGiftCard,
  IconRosetteDiscountCheck,
  IconLifebuoy,
  IconClipboardList,
  IconUsers,
  type Icon,
} from '@tabler/icons-react';

export interface NavItem {
  to: string;
  labelKey: string; // i18n key
  icon: Icon;
}

export interface NavSection {
  titleKey: string;
  items: NavItem[];
}

export const navSections: NavSection[] = [
  {
    titleKey: 'nav.sections.overview',
    items: [
      { to: '/', labelKey: 'nav.items.home', icon: IconLayoutGrid },
      { to: '/dashboard', labelKey: 'nav.items.dashboard', icon: IconLayoutDashboard },
      { to: '/reports', labelKey: 'nav.items.reports', icon: IconChartBar },
      { to: '/live-sales', labelKey: 'nav.items.liveSales', icon: IconActivity },
      { to: '/ai', labelKey: 'nav.items.ai', icon: IconSparkles },
    ],
  },
  {
    titleKey: 'nav.sections.catalog',
    items: [
      { to: '/items', labelKey: 'nav.items.items', icon: IconToolsKitchen2 },
      { to: '/ingredients', labelKey: 'nav.items.ingredients', icon: IconCarrot },
      { to: '/categories', labelKey: 'nav.items.categories', icon: IconCategory },
      { to: '/modifier-groups', labelKey: 'nav.items.modifierGroups', icon: IconReceipt2 },
      { to: '/taxes', labelKey: 'nav.items.taxes', icon: IconReceipt2 },
      { to: '/payment-methods', labelKey: 'nav.items.paymentMethods', icon: IconCash },
      { to: '/promotions', labelKey: 'nav.items.promotions', icon: IconDiscount2 },
    ],
  },
  {
    titleKey: 'nav.sections.operations',
    items: [
      { to: '/inventory', labelKey: 'nav.items.inventory', icon: IconPackage },
      { to: '/production', labelKey: 'nav.items.production', icon: IconToolsKitchen2 },
      { to: '/expiring', labelKey: 'nav.items.expiring', icon: IconClockExclamation },
      { to: '/stock-count', labelKey: 'nav.items.stockCount', icon: IconClipboardCheck },
      { to: '/reorder', labelKey: 'nav.items.reorder', icon: IconShoppingCartPlus },
      { to: '/valuation', labelKey: 'nav.items.valuation', icon: IconCoin },
      { to: '/transfers', labelKey: 'nav.items.transfers', icon: IconArrowsRightLeft },
      { to: '/purchase-orders', labelKey: 'nav.items.purchaseOrders', icon: IconShoppingCart },
      { to: '/suppliers', labelKey: 'nav.items.suppliers', icon: IconTruckDelivery },
      { to: '/selling', labelKey: 'nav.items.selling', icon: IconReceipt2 },
      { to: '/online', labelKey: 'nav.items.online', icon: IconWorld },
      { to: '/projects', labelKey: 'nav.items.projects', icon: IconClipboardList },
      { to: '/support', labelKey: 'nav.items.support', icon: IconLifebuoy },
      { to: '/quality', labelKey: 'nav.items.quality', icon: IconRosetteDiscountCheck },
      { to: '/kitchen-stations', labelKey: 'nav.items.kitchenStations', icon: IconToolsKitchen2 },
      { to: '/floor-plan', labelKey: 'nav.items.floorPlan', icon: IconLayout2 },
      { to: '/labels', labelKey: 'nav.items.labels', icon: IconBarcode },
      { to: '/call-center', labelKey: 'nav.items.callCenter', icon: IconHeadphones },
    ],
  },
  {
    titleKey: 'nav.sections.accounting',
    items: [
      { to: '/accounting', labelKey: 'nav.items.accountingDashboard', icon: IconLayoutDashboard },
      { to: '/accounts', labelKey: 'nav.items.chartOfAccounts', icon: IconCalculator },
      { to: '/journal', labelKey: 'nav.items.journal', icon: IconBook },
      { to: '/accounting-reports', labelKey: 'nav.items.accountingReports', icon: IconReportMoney },
      { to: '/sales-invoices', labelKey: 'nav.items.salesInvoices', icon: IconFileInvoice },
      { to: '/purchase-invoices', labelKey: 'nav.items.purchaseInvoices', icon: IconReceipt2 },
      { to: '/cheques', labelKey: 'nav.items.cheques', icon: IconWriting },
      { to: '/expenses', labelKey: 'nav.items.expenses', icon: IconCash },
      { to: '/fixed-assets', labelKey: 'nav.items.fixedAssets', icon: IconBuildingWarehouse },
      { to: '/accounting-periods', labelKey: 'nav.items.accountingPeriods', icon: IconClockExclamation },
      { to: '/payment-terms', labelKey: 'nav.items.paymentTerms', icon: IconReceipt2 },
      { to: '/cost-centers', labelKey: 'nav.items.costCenters', icon: IconSitemap },
      { to: '/budgets', labelKey: 'nav.items.budgets', icon: IconChartBar },
      { to: '/bank-reconciliation', labelKey: 'nav.items.bankRec', icon: IconBuildingBank },
    ],
  },
  {
    titleKey: 'nav.sections.hr',
    items: [
      { to: '/employees', labelKey: 'nav.items.employees', icon: IconUsers },
      { to: '/roster', labelKey: 'nav.items.roster', icon: IconCalendarEvent },
      { to: '/shift-templates', labelKey: 'nav.items.shiftTemplates', icon: IconClockHour4 },
      { to: '/attendance', labelKey: 'nav.items.attendance', icon: IconClockExclamation },
      { to: '/leave', labelKey: 'nav.items.leave', icon: IconClipboardCheck },
      { to: '/payroll', labelKey: 'nav.items.payroll', icon: IconCash },
    ],
  },
  {
    titleKey: 'nav.sections.organization',
    items: [
      { to: '/branches', labelKey: 'nav.items.branches', icon: IconBuildingStore },
      { to: '/customers', labelKey: 'nav.items.customers', icon: IconUsers },
      { to: '/loyalty', labelKey: 'nav.items.loyalty', icon: IconGift },
      { to: '/gift-cards', labelKey: 'nav.items.giftCards', icon: IconGiftCard },
      { to: '/notifications', labelKey: 'nav.items.notifications', icon: IconMessage2 },
      { to: '/users', labelKey: 'nav.items.users', icon: IconUsers },
      { to: '/roles', labelKey: 'nav.items.roles', icon: IconShieldLock },
      { to: '/audit', labelKey: 'nav.items.audit', icon: IconHistory },
      { to: '/custom-fields', labelKey: 'nav.items.customFields', icon: IconForms },
      { to: '/devices', labelKey: 'nav.items.devices', icon: IconDeviceDesktop },
    ],
  },
];

export const settingsItem: NavItem = {
  to: '/settings',
  labelKey: 'nav.items.settings',
  icon: IconSettings,
};
